export default __webpack_public_path__ + "static/media/ee.51647ada.jpg";